import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {},
  mainActions: {
    height: 35,
    marginBottom: 12,
    marginLeft: 12,
    marginRight: 12,
    marginTop: 24,
    "& .deleteButton": {
      width: "50%",
    },
  },
  columnOneBox: {
    width: "50%",
    marginRight: 24,
    // paddingTop: 12,
    paddingLeft: 12,
    // paddingBottom: 12
  },
  columnTwoBox: {
    flex: 1,
    // paddingTop: 12,
    // paddingBottom: 12,
    marginRight: 12,
  },
  marginInput: {
    marginBottom: "15px",
  },
  checkbox: {
    marginBottom: "15px",
    marginTop: "15px",
  },
  lineSeparator: {
    width: "100%",
    backgroundColor: "#CCDEEE",
    height: 1,
    marginBottom: 12,
  },
  datesSubtitle: {
    marginBottom: 5,
    height: 20,
    fontWeight: 700,
    color: "#465869",
    fontSize: 15,
  },
  cartonQuantitySubtitle: {
    color: "#465869",
    fontSize: 12,
    marginBottom: 12,
    fontWeight: 400,
  },
  cartonQuantityValue: {
    color: "#465869",
    fontSize: 21,
    fontWeight: 700,
  },
  marginTop: {
    marginTop: "8px",
  },
}));

export default styles;
